import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { SearchResultsStore } from 'stores/search-results-store';

import { generateBackToHsrUrlObj } from 'utils/infosite-url-utils';

export const generateAddAnotherPropertyURL = (searchCriteria: SearchCriteriaModel, searchResults: SearchResultsStore): object => {
  searchResults.setExpandForm(true);

  return generateBackToHsrUrlObj(searchCriteria, multiItemCompleteSearchCriteria, { useRewards: false });
};

export const multiItemFlightSearchCriteria = [
  'origin',
  'cabinClass',
  'tripType',
  'airlineCode',
  'directFlights',
  'infantsInSeats',
  'partialStayStartDate',
  'partialStayEndDate',
  'partialStay',
];
export const multiItemCarSearchCriteria = ['pickUpTime', 'dropOffTime', 'driverAge'];
export const multiItemCompleteSearchCriteria = multiItemCarSearchCriteria.concat(multiItemFlightSearchCriteria);
